import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const CityWrapper = styled.div`
    display: flex;
    color: ${COLORS.GRAY_DARK};
    cursor: pointer;
    margin-bottom: 0;
    ${FONTS.MediumXXS};
    align-items: center;
    gap: 4px;
    
    > svg {
        #guts {
            stroke: ${COLORS.GRAY_DARK};
        }
    }
  
    &:hover {
        color: ${COLORS.TextPrimary};
    
        > svg {
            #guts {
                stroke: ${COLORS.TextPrimary};
            }
        }
    }
`;
